import MenuNavegacion from '@componentes/MenuNavegacion/MenuNavegacion';
import './index.css'
import { Link } from 'react-router-dom';
import { useWindowSize } from '@utils/resize';
import MenuNavegacionMobile from '@componentes/MenuNavegacion/MenuNavegacionMobile/MenuNavegacionMobile';
import { useState, useEffect } from 'react';
export default function Cabecera() {
    const { width } = useWindowSize();
    const rootStyles = getComputedStyle(document.documentElement);
    const principalColor = rootStyles.getPropertyValue('--primary-color');
    const [cabecera, setCabecera] = useState("/logo-magenta.png")
    const [ayuntamiento, setAyuntamiento] = useState("TOLEDO")

    useEffect(() => {
        // Cargar el config.json desde la carpeta public
        const loadConfig = async () => {
          try {
            const response = await fetch('/config.json');
            const config = await response.json();
            setCabecera(config.LOGO_AYUNTAMIENTO)
            setAyuntamiento(config.AYUNTAMIENTO)
          } catch (error) {
            console.error('Error loading config:', error);
          }
        };
    
        loadConfig();
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);
    return (
        <div className="encabezado-main">
            <div className="encabezado">
                <Link className='link-cabecera' to='/'>
                    <img
                        src={cabecera}
                        style={{ width: '100px'}}
                        className="encabezado-image"
                        alt="IMAGEN ARROW"
                    />
                    <div className='encabezado-titulo'>
                        <span style={{ fontSize: width > 1200 ? '100%' : '80%', width: width > 1300 ? '170px' : '' }}>AYUNTAMIENTO DE</span>
                        <span style={{ color: principalColor, fontSize: width > 1300 ? '240%' : '200%' }}>{ayuntamiento}</span>
                    </div>

                </Link>
                <div>
                    {
                        width > 1300 ? <MenuNavegacion /> : <MenuNavegacionMobile />
                    }
                </div>
            </div>
        </div>
    );
}